import { FormAPI } from '@philips-internal/oswald-ui-components';
import { BrokerService } from '@philips-internal/oswald-ui-core/lib/services';
import { BS_TASK_LIST_CURRENT_WIZARD_STEP } from '../constants/application-constants';
import TASK_STATUS from '../constants/task-status';
import TaskItem from '../interfaces/task-item';

export class TaskModuleUtils {

  /**
   * Listen for the current step after wizard navigation and enable/disable form editing based on task status.
   * @param formApi FormAPI
   * @param fragmentStepId fragment identifier
   * @param taskItem TaskItem
   */
  static listenerCurrentWizardStepFromParent(formApi: FormAPI, fragmentStepId: string, taskItem: TaskItem): void {
    BrokerService.subscribeToTopic(BS_TASK_LIST_CURRENT_WIZARD_STEP, (stepId: string) => {

      if (fragmentStepId !== stepId) {
        return;
      }

      try {
        switch (taskItem?.ieStatusTarefa) {
          case TASK_STATUS.COMPLETED:
            formApi.setEditing(false);
            formApi.setDisabled(true);
            break;
          case TASK_STATUS.PENDING:
            formApi.setEditing(true);
            formApi.setDisabled(false);
            break;
          default:
            break;
        }
      } catch (e) {
        console.log('Error while setting form editing state based on task status:', e);
      }
    });
  }
}
